<div class="container">
  <mat-card class="card2">
   
          <h4 class="card-title">Edit Offer</h4>
      
      <form  (ngSubmit)="f.form.valid" #f="ngForm">
        <div class="row">
          <div class="col-md-4">
  
                  <mat-form-field class="example-full-width">
          
              <mat-label>Offer Code</mat-label>
              <input matInput placeholder="Offer Code" name="code" [(ngModel)]="addForm.code" #code="ngModel" [ngClass]="{ 'is-invalid': f.submitted && code.invalid }" required />
        
              <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                <div *ngIf="firstName.errors.required">Name is required</div>
            </div>        -->
            </mat-form-field>
           
            <div
            [hidden]="code.valid || code.pristine"
            class="erro1"
          >Offer Code is Required
          </div></div>
            
          <div class="col-md-4">
  
            <mat-form-field class="example-full-width">
    
        <mat-label>Partner Name</mat-label>
        <input matInput placeholder="Offer Partner" name="Partner" [(ngModel)]="addForm.Partner" #Partner="ngModel" />
  
        <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
          <div *ngIf="firstName.errors.required">Name is required</div>
      </div>        -->
      </mat-form-field>
     
      <div
      [hidden]="Partner.valid || Partner.pristine"
      class="erro1"
    >Partner is Required
    </div></div>
          <div class="col-md-4">
  
              
            <mat-form-field class="example-full-width">
              <mat-label>Select Type</mat-label>
              <mat-select [(ngModel)]="addForm.Offer_type"  name="Offer_type" placeholder="Select Type" #ti="ngModel" required>
                  <mat-option value="fixed">Fixed</mat-option>
                  <mat-option value="percentage">Percentage</mat-option>
                </mat-select>
            </mat-form-field>
              <div
            [hidden]="ti.valid || ti.pristine"
            class="erro1"
          >Type is Required
          </div>
  </div>
  <ng-container *ngIf="addForm.Offer_type=='fixed'; else percentage">
     
          <div class="col-md-4">
  
                  <mat-form-field class="example-full-width">
          
              <mat-label>Order Above</mat-label>
              <input matInput placeholder="Order Above" name="above" type="number" [(ngModel)]="addForm.orderAbove" #orderAbove="ngModel" [ngClass]="{ 'is-invalid': f.submitted && orderAbove.invalid }" required />
        
              <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                <div *ngIf="firstName.errors.required">Name is required</div>
            </div>        -->
            </mat-form-field>
           
            <div
            [hidden]="orderAbove.valid || orderAbove.pristine"
            class="erro1"
          >Order Above is Required
          </div>
          </div>  
          <div class="col-md-4">
  
            <mat-form-field class="example-full-width">
    
        <mat-label>Amount</mat-label>
        <input matInput placeholder="Amount" name="amount" type="number" [(ngModel)]="addForm.amount" #amount="ngModel" [ngClass]="{ 'is-invalid': f.submitted && amount.invalid }" required />
  
        <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
          <div *ngIf="firstName.errors.required">Name is required</div>
      </div>        -->
      </mat-form-field>
     
      <div
      [hidden]="amount.valid || amount.pristine"
      class="erro1"
    >Amount Code is Required
    </div>
    </div>  
            <div class="col-md-4">
      
                  <mat-form-field >
                      <mat-label>Start Date</mat-label>
                      <input readonly (click)="picker1.open()" matInput [matDatepicker]="picker1" name="start" [(ngModel)]="addForm.start" #start="ngModel" required>
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field></div>
             
                <div class="col-md-4">
      
                  <mat-form-field >
                      <mat-label>End Date</mat-label>
                      <input  readonly (click)="picker.open()" matInput [matDatepicker]="picker" name="end" [(ngModel)]="addForm.end" #end="ngModel" required>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field></div>
          
             
</ng-container>
<ng-template #percentage>
      <div class="col-md-4">

              <mat-form-field class="example-full-width">
      
          <mat-label>Offer Percentage</mat-label>
          <input matInput placeholder="Offer Percentage" name="Offer_percentage" [(ngModel)]="addForm.Offer_percentage"  #Offer_percentage="ngModel" [ngClass]="{ 'is-invalid': f.submitted && Offer_percentage.invalid }" required />
        
          <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
            <div *ngIf="firstName.errors.required">Name is required</div>
        </div>        -->
        </mat-form-field>
       
        <div
        [hidden]="Offer_percentage.valid || Offer_percentage.pristine"
        class="erro1"
      >Offer Percentage  is Required
      </div>
      </div>  
      <div class="col-md-4">
  
        <mat-form-field class="example-full-width">

    <mat-label>Order Above</mat-label>
    <input matInput placeholder="Order Above" name="above" type="number" [(ngModel)]="addForm.orderAbove" #orderAbove="ngModel" [ngClass]="{ 'is-invalid': f.submitted && orderAbove.invalid }" required />

    <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
      <div *ngIf="firstName.errors.required">Name is required</div>
  </div>        -->
  </mat-form-field>
 
  <div
  [hidden]="orderAbove.valid || orderAbove.pristine"
  class="erro1"
>Order Above is Required
</div>
</div>  
      <div class="col-md-4">

          <mat-form-field class="example-full-width">
  
      <mat-label>Max Fix Amount</mat-label>
      <input matInput placeholder="Max Fix Amount" name="fixamount" [(ngModel)]="addForm.fixamount" #fixamount="ngModel" [ngClass]="{ 'is-invalid': f.submitted && fixamount.invalid }" required />
        
      <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
        <div *ngIf="firstName.errors.required">Name is required</div>
    </div>        -->
    </mat-form-field>
   
    <div
    [hidden]="fixamount.valid || fixamount.pristine"
    class="erro1"
  >Fixamount is Required
  </div>
  </div>  
        <div class="col-md-4">
  
              <mat-form-field >
                  <mat-label>Start Date</mat-label>
                  <input readonly (click)="picker1.open()" matInput [matDatepicker]="picker1" name="start" [(ngModel)]="addForm.start" #start="ngModel" required>
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field></div>
         
            <div class="col-md-4">
  
              <mat-form-field >
                  <mat-label>End Date</mat-label>
                  <input readonly (click)="picker.open()" matInput [matDatepicker]="picker" name="end" [(ngModel)]="addForm.end" #end="ngModel" required>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field></div>
           
         

              </ng-template>

              <div class="col-md-4">
                <mat-form-field class="example-full-width">
              
                  <mat-label>Add Terms And Condtion</mat-label>
                  <input matInput placeholder="Terms And Conditon" name="terms" [(ngModel)]="terms"/>
                  <span class="spanAdd"><button mat-raised-button (click)="addTerms()" class="add">ADD</button></span>
                </mat-form-field>
              </div>


<div class="col-md-4">
  <ng-container *ngIf="!addForm.image.url; else image">
    <label  class="custom">Upload Image   
    
  <input type="file"  accept="image/*"  name="image" (change)="showPreview($event)" />

 
</label></ng-container>
<ng-template #image>
  <img src="{{addForm.image.url}}" class="img">
</ng-template>
<div *ngIf="currentUpload && !addForm.image.url">
  Progress: {{ currentUpload?.progress }}%
  Complete
  <div class="progress">
    <div
      class="progress-bar progress-bar-animated"
      [ngStyle]="{ width: currentUpload?.progress + '%' }"
    ></div>

   
</div></div>

<div *ngIf="addForm.image.url">
  <mat-icon  (click)="deletePreviousFile()">delete</mat-icon></div>
    
</div>

</div>


  <mat-slide-toggle
  [(ngModel)]="addForm.status"
  name="status"
  #status="ngModel"
  >status</mat-slide-toggle
><br><br>      <button mat-raised-button class="add" (click)=" EditOffer()" [disabled]="f.invalid">Edit Offer</button>
  
      </form>
    <br>
 <p *ngIf="addForm.terms.length">Terms And Conditons Are</p>   
<div class="row" *ngIf="addForm.terms.length">

  <div class="col-md-7" *ngFor="let list of addForm.terms">
    <li>{{list}}<span><mat-icon (click)="deleteTerms(list)" style="color: black;" class="close">close</mat-icon></span> </li>
  </div>
</div> 
    
    </mat-card></div>

      